import { parse as peggyParse } from './grammar.js';
export var NodeKindEnum;
(function (NodeKindEnum) {
    NodeKindEnum["Or"] = "Or";
    NodeKindEnum["And"] = "And";
    NodeKindEnum["Group"] = "Group";
    NodeKindEnum["Not"] = "Not";
    NodeKindEnum["Nothing"] = "Nothing";
    NodeKindEnum["Number"] = "Number";
    NodeKindEnum["Qualifier"] = "Qualifier";
    NodeKindEnum["Regex"] = "Regex";
    NodeKindEnum["Text"] = "Text";
})(NodeKindEnum || (NodeKindEnum = {}));
export function hasLocation(node) {
    return node.location !== undefined;
}
export function isContentNode(node) {
    return node.value !== undefined;
}
export function parse(input) {
    const raw = peggyParse(input);
    return raw;
}
export var SearchType;
(function (SearchType) {
    SearchType["Unknown"] = "";
    SearchType["Code"] = "code";
    SearchType["PRs"] = "pr";
    SearchType["Issues"] = "issue";
    SearchType["Discussions"] = "discussion";
    SearchType["Repositories"] = "repo";
    SearchType["Commits"] = "commit";
    SearchType["Packages"] = "package";
    SearchType["Marketplace"] = "marketplace";
    SearchType["Topics"] = "topic";
    SearchType["Users"] = "user";
    SearchType["Orgs"] = "org";
    SearchType["Wikis"] = "wiki";
    SearchType["CodeLegacy"] = "codelegacy";
})(SearchType || (SearchType = {}));
function scopedToType(type, allowed) {
    if (type === SearchType.Unknown)
        return true;
    return allowed.includes(type);
}
export function isQualifierCompatible(type, qualifierKind) {
    const compatible = getCompatibleQualifiers(type);
    return compatible[qualifierKind] || false;
}
export function getCompatibleQualifiers(type) {
    return {
        [SearchType.Unknown]: {},
        [SearchType.Code]: {
            Language: true,
            Repo: true,
            Org: true,
            Symbol: true,
            Is: true,
            Saved: true,
            Path: true,
            Content: true,
            Trait: true,
            Type: true
        },
        [SearchType.PRs]: {
            In: true,
            Sort: true,
            Author: true,
            Assignee: true,
            Mentions: true,
            Commenter: true,
            Involves: true,
            Milestone: true,
            Label: true,
            Language: true,
            Team: true,
            User: true,
            Repo: true,
            Org: true,
            Created: true,
            Updated: true,
            Merged: true,
            Closed: true,
            Comments: true,
            Type: true,
            State: true,
            Is: true,
            No: true,
            Status: true,
            Head: true,
            Base: true,
            Reactions: true,
            Interactions: true,
            Project: true,
            Review: true,
            Archived: true,
            Draft: true,
            Linked: true,
            Saved: true
        },
        [SearchType.Discussions]: {
            Type: true,
            In: true,
            Sort: true,
            Author: true,
            Commenter: true,
            Involves: true,
            User: true,
            Org: true,
            Repo: true,
            Created: true,
            Updated: true,
            Comments: true,
            Is: true,
            Category: true,
            Label: true,
            No: true,
            Saved: true
        },
        [SearchType.Issues]: {
            In: true,
            Sort: true,
            Author: true,
            Assignee: true,
            Mentions: true,
            Commenter: true,
            Involves: true,
            Milestone: true,
            Label: true,
            Language: true,
            Team: true,
            User: true,
            Repo: true,
            Org: true,
            Created: true,
            Updated: true,
            Closed: true,
            Comments: true,
            Type: true,
            State: true,
            Is: true,
            No: true,
            Status: true,
            Reactions: true,
            Interactions: true,
            Project: true,
            Linked: true,
            Saved: true,
            Reason: true
        },
        [SearchType.Repositories]: {
            In: true,
            Sort: true,
            Type: true,
            Size: true,
            Forks: true,
            Fork: true,
            Pushed: true,
            Org: true,
            User: true,
            Repo: true,
            Language: true,
            License: true,
            Created: true,
            Followers: true,
            Stars: true,
            Mirror: true,
            Template: true,
            Is: true,
            Topic: true,
            Archived: true,
            Has: true,
            Saved: true
        },
        [SearchType.Users]: {
            In: true,
            FullName: true,
            Language: true,
            Location: true,
            User: true,
            Org: true,
            Created: true,
            Followers: true,
            Type: true,
            Is: true,
            Saved: true
        },
        [SearchType.Orgs]: {
            In: true,
            FullName: true,
            Language: true,
            Location: true,
            User: true,
            Org: true,
            Created: true,
            Followers: true,
            Type: true,
            Is: true,
            Saved: true
        },
        [SearchType.Wikis]: {
            Updated: true,
            Org: true,
            Repo: true,
            Sort: true,
            In: true,
            Type: true,
            Saved: true
        },
        [SearchType.Topics]: {
            Name: true,
            Created: true,
            Is: true,
            Repositories: true,
            Type: true,
            Saved: true
        },
        [SearchType.Commits]: {
            Is: true,
            Merge: true,
            Sort: true,
            Author: true,
            User: true,
            Org: true,
            Repo: true,
            Type: true,
            Saved: true,
            Sha: true,
            Tree: true
        },
        [SearchType.Packages]: {
            Name: true,
            Sort: true,
            User: true,
            Org: true,
            Repo: true,
            Topic: true,
            Type: true,
            Saved: true
        },
        [SearchType.Marketplace]: {
            Is: true,
            Category: true,
            Name: true,
            Sort: true,
            State: true,
            Type: true,
            Saved: true
        },
        [SearchType.CodeLegacy]: {
            Language: true,
            Repo: true,
            Org: true,
            Fork: true,
            Symbol: true,
            Filename: true,
            Path: true,
            Size: true,
            Saved: true
        }
    }[type];
}
// NOTE: this is generated from the getCompatibleQualifiers mapping above! To
// regenerate it, see the 'check/generate qualifierTypeMapping' test in blackbird.test.ts
const qualifierTypeMapping = {
    Language: [
        SearchType.Code,
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Repositories,
        SearchType.Users,
        SearchType.Orgs
    ],
    Repo: [
        SearchType.Code,
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Commits,
        SearchType.Packages,
        SearchType.Wikis
    ],
    Org: [
        SearchType.Code,
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Commits,
        SearchType.Packages,
        SearchType.Users,
        SearchType.Orgs,
        SearchType.Wikis
    ],
    Symbol: [SearchType.Code],
    Is: [
        SearchType.Code,
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Commits,
        SearchType.Marketplace,
        SearchType.Topics,
        SearchType.Users,
        SearchType.Orgs
    ],
    Saved: [
        SearchType.Code,
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Commits,
        SearchType.Packages,
        SearchType.Marketplace,
        SearchType.Topics,
        SearchType.Users,
        SearchType.Orgs,
        SearchType.Wikis
    ],
    Path: [SearchType.Code],
    Content: [SearchType.Code],
    Trait: [SearchType.Code],
    Type: [
        SearchType.Code,
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Commits,
        SearchType.Packages,
        SearchType.Marketplace,
        SearchType.Topics,
        SearchType.Users,
        SearchType.Orgs,
        SearchType.Wikis
    ],
    In: [
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Users,
        SearchType.Orgs,
        SearchType.Wikis
    ],
    Sort: [
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Commits,
        SearchType.Packages,
        SearchType.Marketplace,
        SearchType.Wikis
    ],
    Author: [SearchType.PRs, SearchType.Issues, SearchType.Discussions, SearchType.Commits],
    Assignee: [SearchType.PRs, SearchType.Issues],
    Mentions: [SearchType.PRs, SearchType.Issues],
    Commenter: [SearchType.PRs, SearchType.Issues, SearchType.Discussions],
    Involves: [SearchType.PRs, SearchType.Issues, SearchType.Discussions],
    Milestone: [SearchType.PRs, SearchType.Issues],
    Label: [SearchType.PRs, SearchType.Issues, SearchType.Discussions],
    Team: [SearchType.PRs, SearchType.Issues],
    User: [
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Commits,
        SearchType.Packages,
        SearchType.Users,
        SearchType.Orgs
    ],
    Created: [
        SearchType.PRs,
        SearchType.Issues,
        SearchType.Discussions,
        SearchType.Repositories,
        SearchType.Topics,
        SearchType.Users,
        SearchType.Orgs
    ],
    Updated: [SearchType.PRs, SearchType.Issues, SearchType.Discussions, SearchType.Wikis],
    Merged: [SearchType.PRs],
    Closed: [SearchType.PRs, SearchType.Issues],
    Comments: [SearchType.PRs, SearchType.Issues, SearchType.Discussions],
    State: [SearchType.PRs, SearchType.Issues, SearchType.Marketplace],
    No: [SearchType.PRs, SearchType.Issues, SearchType.Discussions],
    Status: [SearchType.PRs, SearchType.Issues],
    Head: [SearchType.PRs],
    Base: [SearchType.PRs],
    Reactions: [SearchType.PRs, SearchType.Issues],
    Interactions: [SearchType.PRs, SearchType.Issues],
    Project: [SearchType.PRs, SearchType.Issues],
    Review: [SearchType.PRs],
    Archived: [SearchType.PRs, SearchType.Repositories],
    Draft: [SearchType.PRs],
    Linked: [SearchType.PRs, SearchType.Issues],
    Reason: [SearchType.Issues],
    Category: [SearchType.Discussions, SearchType.Marketplace],
    Size: [SearchType.Repositories],
    Forks: [SearchType.Repositories],
    Fork: [SearchType.Repositories],
    Pushed: [SearchType.Repositories],
    License: [SearchType.Repositories],
    Followers: [SearchType.Repositories, SearchType.Users, SearchType.Orgs],
    Stars: [SearchType.Repositories],
    Mirror: [SearchType.Repositories],
    Template: [SearchType.Repositories],
    Topic: [SearchType.Repositories, SearchType.Packages],
    Has: [SearchType.Repositories],
    Merge: [SearchType.Commits],
    Sha: [SearchType.Commits],
    Tree: [SearchType.Commits],
    Name: [SearchType.Packages, SearchType.Marketplace, SearchType.Topics],
    Repositories: [SearchType.Topics],
    FullName: [SearchType.Users, SearchType.Orgs],
    Location: [SearchType.Users, SearchType.Orgs]
};
export function getCompatibleSearchTypes(qualifierKind) {
    return qualifierTypeMapping[qualifierKind] || [];
}
// Returns a set of possible fixed values for the qualifier (or empty, if there are none).
// The type field is the search type, i.e. code, issues, prs, discussions, topics, etc.
// If the type field is blank, then don't apply any restrictions based on type.
export function getPossibleQualifierValues(type, qualifierKind, today) {
    if (!today) {
        today = new Date();
    }
    if (qualifierKind === 'Sort') {
        // Sort isn't supported in code search
        if (type === SearchType.Code)
            return [];
        return [
            'interactions',
            'interactions-asc',
            'reactions',
            'reactions-asc',
            'author-date',
            'author-date-asc',
            'committer-date',
            'committer-date-asc',
            'updated',
            'updated-asc'
        ];
    }
    else if (qualifierKind === 'No') {
        if (scopedToType(type, [SearchType.Issues, SearchType.PRs, SearchType.Discussions])) {
            return ['label', 'assignee', 'project', 'milestone'];
        }
    }
    else if (qualifierKind === 'Type') {
        return ['user', 'org', 'pr', 'issue', 'discussion', 'marketplace', 'package', 'commit', 'topic', 'wiki'];
    }
    else if (qualifierKind === 'Status') {
        if (scopedToType(type, [SearchType.PRs])) {
            return ['pending', 'failure', 'success'];
        }
    }
    else if (qualifierKind === 'Archived' || qualifierKind === 'Draft') {
        if (scopedToType(type, [SearchType.PRs])) {
            return ['true', 'false'];
        }
    }
    else if (qualifierKind === 'Linked') {
        if (scopedToType(type, [SearchType.Issues, SearchType.PRs])) {
            return ['pr', 'issue'];
        }
    }
    else if (qualifierKind === 'Has') {
        if (scopedToType(type, [SearchType.Repositories])) {
            return ['funding-file'];
        }
    }
    else if (qualifierKind === 'Is') {
        if (scopedToType(type, [SearchType.Code])) {
            return ['archived', 'fork'];
        }
        else if (scopedToType(type, [SearchType.Users])) {
            return ['sponsorable'];
        }
        else if (scopedToType(type, [SearchType.Issues])) {
            return ['open', 'closed', 'public', 'private'];
        }
        else if (scopedToType(type, [SearchType.PRs])) {
            return ['open', 'closed', 'public', 'private', 'merged', 'unmerged'];
        }
        else if (scopedToType(type, [SearchType.Discussions, SearchType.Repositories, SearchType.Commits, SearchType.Packages])) {
            return ['public', 'private', 'issue', 'pr'];
        }
    }
    else if (qualifierKind === 'State') {
        if (scopedToType(type, [SearchType.Issues, SearchType.PRs])) {
            return ['open', 'closed'];
        }
    }
    else if (qualifierKind === 'Review') {
        if (scopedToType(type, [SearchType.PRs])) {
            return ['none', 'required', 'approved', 'changes_requested'];
        }
    }
    else if (qualifierKind === 'Stars') {
        return ['0..100', '200', '<200', '>500', '>1000', '>2000', '>4000'];
    }
    else if (qualifierKind === 'Forks') {
        return ['<5', '50..100', '200', '>500'];
    }
    else if (qualifierKind === 'Reason') {
        return ['completed', 'not planned', 'reopened'];
    }
    else if (qualifierKind === 'Location') {
        return [
            'San Francisco, CA',
            'Bellevue, WA',
            'Brooklyn, NY',
            'Oxford, United Kingdom',
            'Amsterdam, Netherlands',
            'Copenhagen, Denmark',
            'Hyderabad, India',
            'Melbourne, Australia',
            'Tokyo, Japan',
            'Sydney, Australia'
        ];
    }
    else if (qualifierKind === 'License') {
        return ['0bsd', 'cc', 'gpl', 'lgpl', 'apache-2.0'];
    }
    else if (qualifierKind === 'Created' || qualifierKind === 'Updated' || qualifierKind === 'Pushed') {
        const formatDate = (d) => `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
        const startOfWeek = new Date(today.getTime() - today.getDay() * 24 * 3600 * 1000);
        const startOfMonth = new Date(today.getTime());
        startOfMonth.setDate(1);
        const startOfYear = new Date(today.getTime());
        startOfYear.setDate(1);
        startOfYear.setMonth(0);
        return [
            formatDate(today),
            `>${formatDate(startOfWeek)}`,
            `>${formatDate(startOfMonth)}`,
            `>${formatDate(startOfYear)}`
        ];
    }
    return [];
}
//# sourceMappingURL=blackbird.js.map